import { render, staticRenderFns } from "./ExpiredRecord.vue?vue&type=template&id=611dcd1a&scoped=true&"
import script from "./ExpiredRecord.vue?vue&type=script&lang=js&"
export * from "./ExpiredRecord.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredRecord.vue?vue&type=style&index=0&id=611dcd1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611dcd1a",
  null
  
)

export default component.exports